export default __webpack_public_path__ + "static/media/hamburguer.104ec644.svg";